module.exports = __webpack_public_path__ + "img/hodlnaut.7b964d83.png";